<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useAuthStore } from '@/store/auth'

const { supportLogin } = useAuthStore()
const route = useRoute()
const router = useRouter()

onMounted(async () => {
  const isSupport = await supportLogin({
    accessToken: route.query.supportToken as string,
    selectedOrganizationId: route.query.organizationId as string,
    selectedLocationId: route.query.locationId as string
  })
  if (isSupport) {
    router.push({ name: 'board' })
  } else {
    router.push({ name: 'login' })
  }
})
</script>
